import React, { FunctionComponent } from 'react';
import { isNaN, isFinite } from 'lodash';

import {
  asPercentage,
  asPercentageRounded,
  numberWithCommas,
  removeLineBreaks,
} from 'spw-shared/utils';
import { Grid } from '@mui/material';
import {
  AsteriskContainer,
  ChildName,
} from 'spw-programming-projects/program-summary/macro-single-page-summary/styles';
import { CategorySeatTypeMixSubtotalsChildRowProps } from '../program-summary-config';

export const CategorySeatTypeMixSubtotalsChildRow: FunctionComponent<CategorySeatTypeMixSubtotalsChildRowProps> = ({
  row,
  totalSeats,
  showDecimals,
  shouldShowClientFacingName,
}) => {
  const testingPrefixForRow = `programming_ps_seat_type_mix_subtotals_row_child_${row?.spaceType?.id}`;
  const seats = row.quantity * row.seatCap;
  const sum = numberWithCommas(seats, showDecimals, true);

  const percent = totalSeats ? seats / totalSeats : 0;
  let percentValue = '0%';

  if (!isNaN(percent) && isFinite(percent)) {
    percentValue = showDecimals
      ? asPercentage(percent)
      : asPercentageRounded(percent, false);
  }

  return (
    <Grid container key={`row-${row.id}`}>
      <Grid item xs={6}>
        <ChildName
          className="no-margin"
          data-testid={`${testingPrefixForRow}_spaceTypeName`}
        >
          <pre>
            {removeLineBreaks(
              shouldShowClientFacingName &&
                row.projectSpaceType.clientFacingName
                ? row.projectSpaceType.clientFacingName
                : row.spaceType.name
            )}
          </pre>
        </ChildName>
      </Grid>
      <Grid item xs={2}>
        <ChildName
          style={{
            textAlign: 'right',
          }}
          className="value"
          data-testid={`${testingPrefixForRow}_seats`}
        >
          {sum}
          {!row.isIncludedInTotalWorkSeats && (
            <AsteriskContainer>*</AsteriskContainer>
          )}
        </ChildName>
      </Grid>
      <Grid
        item
        xs={4}
        style={{
          textAlign: 'right',
          paddingBottom: '8px',
        }}
      >
        <ChildName data-testid={`${testingPrefixForRow}_seatMix`}>
          {row.isIncludedInTotalWorkSeats
            ? percentValue
            : `1: ${numberWithCommas(row.ratio, showDecimals, true)}`}
        </ChildName>
      </Grid>
    </Grid>
  );
};
